import type { WrappedTimestamp } from '../providers/client-provider';
import type { DistanceType } from './event';
import type { ID, Model } from './models';
import type { File } from './photo';
import type { RunResult } from './user';

export enum CampaignApplicationType {
  RACE_ENTRY_PROMOTION = 'race-entry-promotion',
  TOKYO_MARATHON_PROMOTION = 'tokyo-marathon-promotion',
  BEYOND_2026_PROMOTION = 'beyond-2026-promotion',
  ASK_A_COACH = 'ask-a-coach',
}

export enum CampaignApplicationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum RaceEntryPromotionCategory {
  ROAD = 'road',
  TRACK = 'track',
  TRAIL = 'trail',
  TRIATHLON = 'triathlon',
  DUATHLON = 'duathlon',
}

export interface CampaignApplicationCommon {
  type: CampaignApplicationType;
  userId: ID;

  status: CampaignApplicationStatus;

  approvalDate?: WrappedTimestamp;
  approverId?: ID;
  approverName?: string;

  rejectionDate?: WrappedTimestamp;
  rejectorId?: ID;
  rejectorName?: string;
}

export type SpecificRaceEntryPromotionApplicationType =
  CampaignApplicationType.TOKYO_MARATHON_PROMOTION | CampaignApplicationType.BEYOND_2026_PROMOTION;

export interface RaceEntryPromotionApplication extends CampaignApplicationCommon, Model {
  type: CampaignApplicationType.RACE_ENTRY_PROMOTION | SpecificRaceEntryPromotionApplicationType;
  raceName: string;
  category: RaceEntryPromotionCategory;
  distance: DistanceType;
  distanceInMeters?: number;
  officialRaceUrl: string;
  proofOfEntry: File;
  goal?: RunResult | null;

  eventId: ID;
}

export interface AskACoachApplication extends CampaignApplicationCommon, Model {
  type: CampaignApplicationType.ASK_A_COACH;
  question: string;

  topicId: ID;
}

export type CampaignApplication = RaceEntryPromotionApplication | AskACoachApplication;
